// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_auth_auth_module_ts":"b7fbb9901760f597","src_app_modules_shopify-order-tracking_shopify-order-tracking_module_ts":"845fc9b6dff34ea7","src_app_modules_order-details_order-details_module_ts":"08547fd062830966"}[chunkId] + ".js";
};